/* ============================================================
   SARABANDA · CRANS-MONTANA — Core JS
   Scroll reveal delicato. Nessuna libreria esterna.
   Rispetta prefers-reduced-motion. Non tocca cart/checkout/varianti.
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Abilita il fade solo se l'ambiente esegue davvero le transizioni di opacità */
  function probeFx() {
    if (reduce) return;
    var p = document.createElement("div");
    p.style.cssText = "position:fixed;left:-9999px;top:0;width:2px;height:2px;opacity:0;transition:opacity .2s linear;pointer-events:none;";
    document.body.appendChild(p);
    void p.offsetWidth; p.style.opacity = "1";
    setTimeout(function () {
      if (parseFloat(getComputedStyle(p).opacity) > 0.05) document.documentElement.classList.add("scm-fx");
      p.remove();
    }, 90);
  }

  function reveal() {
    var els = [].slice.call(document.querySelectorAll(".scm-reveal"));
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("scm-in"); });
      return;
    }
    function sweep() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      els.forEach(function (el) {
        if (el.classList.contains("scm-in")) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) el.classList.add("scm-in");
      });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("scm-in"); io.unobserve(e.target); } });
    }, { threshold: 0.06, rootMargin: "0px 0px -6% 0px" });
    els.forEach(function (el) { io.observe(el); });
    sweep();
    window.addEventListener("load", sweep);
    window.addEventListener("scroll", sweep, { passive: true });
    setTimeout(sweep, 300);
  }

  /* Neve/sparkles delicati sulla hero overlay */
  function heroSnow() {
    if (reduce) return;
    [].slice.call(document.querySelectorAll(".scm-hero__sparkles")).forEach(function (wrap) {
      if (wrap.childElementCount) return;
      for (var i = 0; i < 18; i++) {
        var sp = document.createElement("span");
        sp.className = "scm-sp";
        var size = (Math.random() * 3 + 2).toFixed(1);
        sp.style.width = sp.style.height = size + "px";
        sp.style.left = (Math.random() * 100).toFixed(1) + "%";
        sp.style.top = (Math.random() * 100).toFixed(1) + "%";
        sp.style.animationDelay = (Math.random() * 6).toFixed(1) + "s";
        sp.style.animationDuration = (Math.random() * 4 + 5).toFixed(1) + "s";
        wrap.appendChild(sp);
      }
    });
  }

  /* Micro-parallax leggero sulla media della hero overlay (non invasivo) */
  function heroParallax() {
    if (reduce) return;
    var medias = [].slice.call(document.querySelectorAll(".scm-hero--overlay .scm-hero__media"));
    if (!medias.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      medias.forEach(function (m) {
        var hero = m.closest(".scm-hero");
        if (!hero) return;
        var rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var off = Math.max(-1, Math.min(1, -rect.top / vh));
        m.style.transform = "scale(1.06) translate3d(0," + (off * 16).toFixed(1) + "px,0)";
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { requestAnimationFrame(update); ticking = true; } }
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  /* Hero slider (4 slot collezioni) — scroll-snap + dots + autoplay */
  function heroSlider() {
    [].slice.call(document.querySelectorAll("[data-hero-slider]")).forEach(function (sl) {
      var track = sl.querySelector(".scm-hero__slides");
      var items = [].slice.call(sl.querySelectorAll(".scm-hero__slide"));
      var dots = [].slice.call(sl.querySelectorAll(".scm-hero__dot"));
      if (!track || items.length < 2) { if (dots[0]) dots[0].classList.add("scm-on"); return; }
      var idx = 0, timer = null;
      var auto = sl.getAttribute("data-autoplay") !== "false" && !reduce;
      function sync() { dots.forEach(function (d, di) { d.classList.toggle("scm-on", di === idx); }); }
      function go(n) { idx = (n + items.length) % items.length; track.scrollTo({ left: idx * track.clientWidth, behavior: "smooth" }); sync(); }
      function restart() { if (!auto) return; clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, 5000); }
      dots.forEach(function (d, di) { d.addEventListener("click", function () { go(di); restart(); }); });
      track.addEventListener("scroll", function () {
        var n = Math.round(track.scrollLeft / track.clientWidth);
        if (n !== idx) { idx = n; sync(); }
      }, { passive: true });
      sl.addEventListener("mouseenter", function () { clearInterval(timer); });
      sl.addEventListener("mouseleave", restart);
      sync(); restart();
    });
  }

  function boot() { probeFx(); reveal(); heroSnow(); heroParallax(); heroSlider(); }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  // re-init nel Theme Editor
  document.addEventListener("shopify:section:load", function () { reveal(); heroSnow(); });
})();
